var render = function render(){var _vm=this,_c=_vm._self._c;return _c('transition',{attrs:{"name":"fade"}},[_c('OrderList',{attrs:{"with-branch-filter":false,"url-to-fetch-orders":`/api/orders/user/${_vm.getAuthUserDetails.userId}`}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }